<template>
  <div class="chargingTime1">
    <title1 type="1" title="告警等级占比" subTitle="Electric Port Overview" :right="true">
      <template v-slot:uuid>
        <!-- <span> 单位 : 座</span> -->
      </template>
    </title1>
    <div ref="piethree" id="pieon3" class="pieon3"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { onMounted, ref } from "vue";
import title1 from "@/views/exposition/components/title4";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    title1,
  },
  data() {
    return {
      chart: null,
      target: [],
      query: this.$route.query,
    };
  },
  mounted() {
    console.log("光伏场站类型统计");
    this.chargingTime();
  },
  methods: {
    // 创建图表
    createChartHandler() {
      this.chart = echarts.init(document.getElementById("pieon3"));
      this.chart.setOption(this.getChartOption(this.target));
      window.addEventListener("resize", () => {
        setTimeout(() => {
          this.chart.resize();
        });
      });
    },
    chargingTime() {
      console.log("调接口没");
      let cityCode = this.query.province || this.query.city || "000000";
      console.log(cityCode, "hsdjssh");
      let params = {
        enCode: "zngf-qg-gfczlxtj", // 接口code
        "@adcode": cityCode,
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "光伏场站类型统计");
          let data1 = res || {};
          this.target = data1.map((item) => {
            return {
              value: item.solar_power_num,
              name: item.photovoltaic_type,
            };
          });
          console.log(this.target, "createChartHandler");
          this.createChartHandler();
        })
        .catch((err) => {
          console.log(err);
        });
      return this.target;
    },
    getChartOption(data1) {
      // console.log(JSON.parse(JSON.stringify(data1)), "data1");
      const piethree = ref(null);
      // const data = this.target || [];
      const data = [
        {
          name: "一级告警",
          value: 45.32,
        },
        {
          name: "二级告警",
          value: 28.35,
        },
        {
          name: "三级告警",
          value: 11.98,
        },
        {
          name: "四级告警",
          value: 14.35,
        },
      ];
      console.log("data:", data);
      this.chart.setOption({
        // 图例设置
        legend: {
          orient: "vertical",
          top: "10%",
          right: "0%",
          itemWidth: 12,
          itemHeight: 8,
          // itemGap: 25,
          formatter: function (name) {
            //通过name获取到数组对象中的单个对象
            console.log(name, "sisiisisis");
            let singleData = data.filter(function (item) {
              return item.name == name;
            });
            let nameValue = singleData[0].value;
            return [`{num|${name}}` + `{name|${nameValue}%}`];
          },
          textStyle: {
            color: ["red", "orange", "skyblue", "green"],
            fontSize: 18,
            rich: {
              name: {
                fontSize: 18,
                fontFamily: "HT",
                // color: "#ffaa00",
                padding: [0, 0, 0, 20], //上，右，下，左
              },
              num: {
                fontSize: 18,
                padding: [0, 0, 0, 0], //上，右，下，左
                // padding: [10, 10],
              },
            },
          },
        },
        // 系列数据设置
        series: [
          {
            name: "Nightingale Chart", // 系列名称
            type: "pie", // 图表类型为饼图
            radius: [10, 110], // 饼图的内外半径
            center: ["30%", "46%"], // 饼图的中心位置
            roseType: "area", // 玫瑰图类型为区域玫瑰图
            itemStyle: {
              borderRadius: 4,
              // 数据项的样式设置
              normal: {
                //取消指示提示文字
                label: {
                  // formatter: "{b}: {d}%",
                  // formatter: function (data) {
                  //   //通过name获取到数组对象中的单个对象
                  //   console.log(data, "世界");
                  //   let str = data.name;
                  //   console.log(str, "name");
                  //   var result = "";
                  //   for (var i = 0; i < str.length; i++) {
                  //     result += str[i];
                  //     if ((i + 1) % 2 === 0) {
                  //       result += "\n";
                  //     }
                  //   }
                  //   console.log(data.value, "result");
                  //   return [`${result}` + `${data.percent}%`];
                  // },
                  show: false,
                  fontSize: 12,
                  fontFamily: "HT",
                },
                // 取消指示提示线
                labelLine: {
                  show: false,
                },
              },
            },
            color:  ["red", "orange", "skyblue", "green"],
            // 数据
            data: data,
          },
        ],
      });

      return { piethree };
    },
    insertNewlineEvery5Characters(str) {
      var result = "";
      for (var i = 0; i < str.length; i++) {
        result += str[i];
        if ((i + 1) % 6 === 0) {
          result += "\n";
        }
      }
      return result;
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "HT";
  src: url("~@/assets/font/HT.ttf");
}
#pieon3 {
  width: 440px;
  height: 280px;
  /* z-index: 10000; */
}
</style>
